module.exports = __webpack_public_path__ + "img/logo13.64c9ceb0.png";